import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS } from "library/shared";
import { IBenefitImplementation } from "library/types";
import { useMutation } from "react-query";
import api from "service/api";
import { useInvalidateBenefitCategories } from "./useGetBenefitCategories";
import { useInvalidateBenefitImplementations } from "./useGetBenefitImplementations";

type Params = {
  countryCode: number | string;
  benefitCategoryTag: number | string;
  clientInternalNumberGOS: number | string;
  payload: IBenefitImplementation;
};

const createBenefitImplementation = async ({
  countryCode,
  clientInternalNumberGOS,
  benefitCategoryTag,
  payload,
}: Params) => {
  const response = await api.post(
    `/benefitimplementation/${countryCode}/${clientInternalNumberGOS}/${benefitCategoryTag}`,
    payload
  );

  return response.data as IBenefitImplementation;
};

export function useCreateBenefitImplementation(
  refetch = true,
  refetchCategory = false
) {
  const invalidateCategories = useInvalidateBenefitCategories();
  const invalidateImplementations = useInvalidateBenefitImplementations();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation(createBenefitImplementation, {
    mutationKey: MUTATION_KEYS.createBenefitImplementation,
    onSuccess: () => {
      if (refetch) {
        invalidateImplementations();
      }
      if (refetchCategory) {
        invalidateCategories();
      }
      //queryClient.invalidateQueries({ queryKey: QUERY_KEYS.clientsByCountry });
      // queryClient.invalidateQueries({ queryKey: QUERY_KEYS.benefitCategories });
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
